import React from 'react';

type SegmentTrackingContextValue = {
  segment_tracking_enabled: boolean;
};

export const SegmentTrackingContext =
  React.createContext<SegmentTrackingContextValue>({
    segment_tracking_enabled: false,
  });

export const SegmentTrackingProvider = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: SegmentTrackingContextValue;
}) => {
  return (
    <SegmentTrackingContext.Provider value={value}>
      {children}
    </SegmentTrackingContext.Provider>
  );
};

export const useSegmentTracking = () => {
  const context = React.useContext(SegmentTrackingContext);
  if (!context) {
    throw new Error(
      'useSegmentTracking must be used within a SegmentTrackingProvider'
    );
  }
  return context;
};
